// 3rd
import { Model } from '@vuex-orm/core';
// models
import Brand from './Brand';
import HeroNews from './HeroNews';
import NewsCategory from './NewsCategory';
// utils
import {
    api,
    authHeaders,
    errorHandler,
} from '../utils/api';
import env from '../utils/env';
import {
    API_ENDPOINT_FETCH_NEWS,
    API_ENDPOINT_FETCH_NEWS_DETAIL,
    API_ENDPOINT_FETCH_NEWS_LATEST,
    LOADER_FETCH_NEWS,
    LOADER_FETCH_NEWS_DETAIL,
    LOADER_FETCH_NEWS_LATEST,
} from '../utils/constants';

export default class News extends Model {
    static entity = 'news-articles';

    static fields() {
        return {
            id: this.attr(null),
            headline: this.attr(null),
            teasertext: this.attr(null),
            content: this.attr(null),
            image_header: this.attr(''),
            image_preview: this.attr(''),
            image_gallery: this.attr(null),
            date_of_news: this.attr(null),
            brands: this.attr(null),
            categories: this.attr(null),
            downloads: this.attr(null),
            custom_downloads_headline: this.attr(null),
            custom_gallery_headline: this.attr(null),
            related_brands: this.hasManyBy(Brand, 'brands'),
            related_categories: this.hasManyBy(NewsCategory, 'categories'),
            is_hero: this.boolean(false),
            country_groups: this.attr([]),
        }
    }

    // api calls
    static async fetch() {
        News.store().dispatch('wait/start', LOADER_FETCH_NEWS);

        const response = await api.get(API_ENDPOINT_FETCH_NEWS, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data } = response;
        const { news } = data;

        News.insert({ data: news });

        News.store().dispatch('wait/end', LOADER_FETCH_NEWS);
    }

    static async fetchLatest() {
        News.store().dispatch('wait/start', LOADER_FETCH_NEWS_LATEST);

        const response = await api.get(API_ENDPOINT_FETCH_NEWS_LATEST, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data } = response;
        const {
            hero,
            news,
        } = data;


        if (hero) {
            HeroNews.insert({ data: hero });
        }

        News.insert({ data: news });

        News.store().dispatch('wait/end', LOADER_FETCH_NEWS_LATEST);
    }

    static async fetchDetails(id) {
        News.store().dispatch('wait/start', LOADER_FETCH_NEWS_DETAIL);

        const response = await api.get(`${API_ENDPOINT_FETCH_NEWS_DETAIL}${id}`, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data } = response;
        const { news } = data;

        News.insert({ data: news });

        News.store().dispatch('wait/end', LOADER_FETCH_NEWS_DETAIL);
    }

    // getters
    static getFiltered(categoryFilter, brandFilter) {
        return News.query().where('categories', (ids) => {
            if (categoryFilter) {
                return ids.includes(categoryFilter);
            } else {
                return true;
            }
        }).where('brands', (ids) => {
            if (brandFilter.length <= 0) {
                return ids;
            } else {
                return ids.some(r => brandFilter.indexOf(r) >= 0)
            }
        }).orderBy('date_of_news', 'desc').withAll().get();
    }

    static getDetails(id) {
        return News.query().withAll().find(id);
    }

    static getLatest() {
        return News
            .query()
            .orderBy('date_of_news', 'desc')
            .where((item) => {
                return item.id !== HeroNews.get().id
            })
            .withAll()
            .limit(env('dashboard-news-limit'))
            .get();
    }
}
